
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CompanyOffersService } from "app/company-offers/services/company-offers.service";
import { LoanOfferGenService } from "app/loan/services/loan-offer-gen.service";
import * as emiGlobals from 'app/globals';
import { EmiBaseInfoService } from "app/shared/services/emi-base-info.service";

@Component({
  selector: 'loan-apply-form',
  templateUrl: './loan-apply-form.component.html',
  styleUrls: ['./loan-apply-form.component.css'],
  providers:[
    CompanyOffersService,
  ]
})
export class LoanApplyFormComponent implements OnInit {
  portalName: any;
  portalInfo: any;
  userInputValues: string;
  userInpt: any;
  HideOfferName: any;
  PortalHodeOffer: any;
  selectedoffer: any;
  fakeArray = new Array(12);
 minuets: any[];
 p:any;
 InputFieldValue;
 whatsAppText;

 options_gender = emiGlobals.GenderEnum;
 option_workexp =emiGlobals.WorkExperienceEnum;

 @Input() input;
 @Input() whtasAppNumber;
 @Input() offer;
 @Input() Messenger;
  // The FormGroup object as you may remember from the simple form example exposes various API’s for dealing with forms. Here we are creating a new object and setting its type to FormGroup
  loanApplyForm : FormGroup;

  //Show Form
  showForm:boolean=true;

  //Show Thanks You div
  showThankYou:boolean=false;

  agentInfo=false;


  // We are passing an instance of the FormBuilder to our constructor
  constructor(
    fb: FormBuilder,
    private companyOffersService:CompanyOffersService,
    private loanOfferService:LoanOfferGenService,
    private baseInfoService:EmiBaseInfoService,
  ){
 
  let p_info=localStorage.getItem('portalInfo');
  if(p_info){
    this.portalInfo=JSON.parse(p_info);
    this.portalName='https://'+this.portalInfo.portal_name+'.eloan.loan';

  }
    
    // alert(this.chatcontent.testing);
  

    this.minuets=['00','15','30','45'];
    this.p=['AM','PM'];
    // Here we are using the FormBuilder to build out our form.
    this.loanApplyForm = fb.group({
      // We can set default values by passing in the corresponding value or leave blank
      // if we wish to not set the value.
      // To add a validator, we must first convert the string value into an array.
      // The first item in the array is the default value if any, then the next item in the array is the validator.
      // Here we are adding a required validator meaning that the name attribute must have a value in it.
      // We can use more than one validator per field.
      // If we want to use more than one validator we have to wrap our array of validators with a Validators.
      // compose function. Here we are using a required, minimum length and maximum length validator.
      'name': [loanOfferService.getLocalLeadContactData('name'), Validators.compose([Validators.required, Validators.minLength(3)])],
      'email': [loanOfferService.getLocalLeadContactData('email'), Validators.compose([Validators.required, Validators.email])],
      'contact_number' : [loanOfferService.getLocalLeadContactData('contact_number'), Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(10)])],
      'contact_at' : [ new Date()],
      'hour':[9],
      'minuet':['30'],
      'am_pm':['AM'],


    });

     baseInfoService.pageDataFetched$.subscribe(
      data => {
        this.getPageData();
      });
      
  }

  ngOnInit() {
    console.log('----------------------offerofferoffer' , this.offer);
    debugger
    console.log(this.Messenger);
    this.selectedoffer=this.offer;
 
    if(this.offer.offer_type=='home_loan_gen'){
      if(this.input){
        this.userInpt=JSON.parse(this.input);
       
       this.userInputValues='Salary:'+this.userInpt.netsal+',Age:'+this.userInpt.age+',LoanAmount:'+this.userInpt.loanamt+
       ',PropertyValue:'+this.userInpt.propval+',EMI:'+this.userInpt.ex_emi+'Loan Type:'+'Home Loan';
      //  JSON.stringify(this.option_workexp[parseInt(this.userInpt.workexp)].name)+',Gender:'+JSON.stringify(this.options_gender[parseInt(this.userInpt.gender)].name);
      }
    }

    if(this.offer.offer_type=='personal_loan_gen'){
      debugger
       if(this.input){
        this.userInpt=JSON.parse(this.input);
        console.log('input values',this.userInpt);
       this.userInputValues='Salary:'+this.userInpt.netsalary+',Age:'+this.userInpt.age+',LoanAmount:'+this.userInpt.loanamount+
       ',EMI:'+this.userInpt.emi+',Loan Type:'+'Personal Loan';
      
      }
      // this.userInputValues='personal-loan'
      
    }
  
    // +
    //

    let selected_offer='BankName:'+this.selectedoffer.name+',LoanInterest:'+this.selectedoffer.bank_interest+
                        ',Type:'+this.selectedoffer.lead_type+',LoanAmount:'+this.selectedoffer.loanamount+
                        ',Emi:'+this.selectedoffer.emi+',PartPay:'+this.selectedoffer.part_pay;
   
    this.whatsAppText='UserInput:['+(this.userInputValues?this.userInputValues:'default_offer')+']:::'+',SelectedOffers:['+selected_offer+']'+',:::PortalName:['+this.portalName+']';
    this.getPageData();
  }

  // Again we’ll implement our form submit function.
  submitForm(data: any):void{
    debugger
      let month;
      let contact;
      let contact_time;

      if(data.contact_at){
        month=parseInt(data.contact_at.getMonth())+1;
        contact= data.contact_at.getDate()+'-'+month+'-'+data.contact_at.getFullYear();
    }
      contact_time=data.hour+':'+data.minuet+':'+data.am_pm;
      data.contact_me_at='date:'+contact+' time:'+contact_time;
      delete data.contact_at;
      delete data.hour;
      delete data.minuet;
      delete data.am_pm;
      localStorage.setItem('lead_contact',JSON.stringify(data));
      console.log('lead_contact',JSON.stringify(data));
      this.companyOffersService.sentLeadInformation().subscribe(
        data  => {
          console.log(data);
          this.loanOfferService.loanFormSubmitted(data);
        },
        error =>  {
          console.log(error);
        }
    );
    this.showForm=false;
    this.showThankYou=true;
  }

    getPageData(){
    try {
      if(localStorage.getItem(emiGlobals.agentInfo)&&localStorage.getItem(emiGlobals.agentInfo)!=undefined){
        this.agentInfo = JSON.parse(localStorage.getItem(emiGlobals.agentInfo));
      }
    } catch (error) {
      console.log(error);
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/loan/loan-apply-form/loan-apply-form.component.ts